import { WithReservationId } from '@mews-commander/types';
import { useReservationsSuspenseQuery } from '@mews-commander/legacy-entities/src/queries/reservations';

const extent = {
    generalNotes: true,
    channelManagerNotes: true,
    specialRequestNotes: true,
};

export const useReservationNotesQuery = ({ reservationId }: WithReservationId) => {
    const { data, isFetching } = useReservationsSuspenseQuery(
        { reservationIds: [reservationId], extent },
        { select: (reservation) => reservation.notes }
    );

    return { data: data || [], isFetching };
};
